import React from 'react'
import { Table } from 'semantic-ui-react'

const Products = ({ data }) => {
  const columns = [
    ...new Set(data.reduce((acc, x) => acc.concat(Object.keys(x)), [])),
  ]

  return (
    <Table celled stackable collapsing>
      <Table.Header>
        <Table.Row>
          {columns.map(col => (
            <Table.HeaderCell key={col}>{col}</Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {data.map((d, i) => (
          <Table.Row key={i}>
            {columns.map(col => (
              <Table.Cell key={col} verticalAlign="top">
                <span dangerouslySetInnerHTML={{ __html: d[col] }} />
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  )
}

export default Products
